import InicioAdm from "@/components/adm/Template"

import Usuario from "@/components/adm/usuario/UsuarioEditar"
import Dashboard from "../componentes/dashboard/Dashboard"
import Relatorio from "../componentes/relatorio/Relatorio"
import FornecedoresListagem from '../componentes/fornecedores/FornecedoresListagem.vue'
import TipoUnidadesListagem from '../componentes/tp-unidades/TipoUnidadesListagem.vue'
import TipoFornecimentoListagem from '../componentes/tp-fornecimento/TipoFornecimentoListagem.vue'
import CadastroContasListagem from '../componentes/cadastro-contas/CadastroContasListagem.vue'
import UnidadesListagem from '../componentes/unidades/UnidadesListagem.vue'

export const routes = [
    {
        path: '/',
        component: InicioAdm,
        children: [
            {
                path: 'dashboard',
                alias: '',
                component: Dashboard,
                name: 'DashboardRota',
            },
        ],
    },

    {
        path: '/cadastros',
        component: InicioAdm,
        children: [
            {
                path: 'contas',
                alias: '',
                component: CadastroContasListagem,
                name: 'CadastroContas',
                meta: {description: 'Overview of environment'}
            }
        ],
    },

    {
        path: '/fornecedores',
        component: InicioAdm,
        children: [
            {
                path: 'listagem',
                alias: '',
                component: FornecedoresListagem,
                name: 'FornecedoresRota',
                meta: {description: 'Overview of environment'}
            }
        ]
    },

    {
        path: '/relatorio/:filtro',
        component: InicioAdm,
        children: [
            {
                path: 'listagem',
                alias: '',
                component: Relatorio,
                name: 'RelatorioRota',
                props: true,
                meta: {description: 'Overview of environment'}
            }
        ]
    },

    {
        path: '/tipo-unidades',
        component: InicioAdm,
        children: [
            {
                path: 'listagem',
                alias: '',
                component: TipoUnidadesListagem,
                name: 'TipoUnidadesRota',
                meta: {description: 'Overview of environment'}
            }
        ]
    },

    {
        path: '/tipo-fornecimentos',
        component: InicioAdm,
        children: [
            {
                path: 'listagem',
                alias: '',
                component: TipoFornecimentoListagem,
                name: 'TipoContasRota',
                meta: {description: 'Overview of environment'}
            }
        ]
    },

    {
        path: '/cadastro-contas',
        component: InicioAdm,
        children: [
            {
                path: 'listagem',
                alias: '',
                component: CadastroContasListagem,
                name: 'CadastroContasRota',
                meta: {description: 'Overview of environment'}
            }
        ]
    },

    {
        path: '/unidades',
        component: InicioAdm,
        children: [
            {
                path: 'listagem',
                alias: '',
                component: UnidadesListagem,
                name: 'UnidadesRota',
                meta: {description: 'Overview of environment'}
            }
        ]
    },

    {
        path: '/usuario',
        component: InicioAdm,
        children: [
            {
                path: 'editar',
                alias: '',
                component: Usuario,
                name: 'Usuario'
            }
        ]
    },

    { path: '*', redirect: '/' }
];

export default routes;
